import * as React from "react";
import { SVGProps } from "react";
const SvgChevronBoldLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.03 27.99a.996.996 0 0 1-.549-.165c-4.194-2.755-8.312-6.302-11.909-10.259a2.362 2.362 0 0 1 0-3.152c3.594-3.956 7.712-7.504 11.91-10.26a1 1 0 0 1 1.097 1.671c-4.059 2.666-8.044 6.101-11.528 9.934a.358.358 0 0 0 .001.461c3.485 3.835 7.471 7.27 11.527 9.933a1 1 0 0 1-.43 1.83l-.12.006.001.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronBoldLeft;
